import { createSlice } from "@reduxjs/toolkit";

const mngrSlice = createSlice({
  name: "mngr",
  initialState: {
    home: null,
    tamima: null,
    social: null,
    character: null,
    blog: null,
    roadmap: null,
    whitepaper: null,
    users: null,
  },
  reducers: {
    setHomeData: (state, action) => {
      state.home = action.payload;
    },
    setTamimaData: (state, action) => {
      state.tamima = action.payload;
    },
    setSocialData: (state, action) => {
      state.social = action.payload;
    },
    setCharacterData: (state, action) => {
      state.character = action.payload;
    },
    setBlogData: (state, action) => {
      state.blog = action.payload;
    },
    setRoadmapData: (state, action) => {
      state.roadmap = action.payload;
    },
    setWhitepaperData: (state, action) => {
      state.whitepaper = action.payload;
    },
    setUsersData: (state, action) => {
      state.users = action.payload;
    },
  },
});

export const {
  setHomeData,
  setTamimaData,
  setSocialData,
  setCharacterData,
  setBlogData,
  setRoadmapData,
  setWhitepaperData,
  setUsersData,
} = mngrSlice.actions;

export default mngrSlice.reducer;
